<template>
    <b-row>
        <b-col v-for="(status, index) in statusLista" :key="status">
            <app-box
                :titulo="status"
                :corBox="corBox(status)"
                :corTexto="corTexto(status)"
                >{{ totaisLista[index] | currency }}</app-box
            >
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        totaisStatus: {
            type: Object,
            default: () => {}
        }
    },

    methods: {
        corTexto(status) {
            switch (status) {
                case 'CONCLUÍDO':
                    return 'success'
                    break
                case 'REPROVADO':
                    return 'danger'
                    break
                case 'REPROVADO PELO SETOR FINANCEIRO':
                    return 'danger'
                    break
                case 'CRIADO':
                    return 'secondary'
                    break
                default:
                    break
            }
            return 'primary'
        },

        corBox(status) {
            return this.corTexto(status)
        }
    },

    computed: {
        statusLista() {
            return Object.keys(this.totaisStatus)
        },

        totaisLista() {
            return Object.values(this.totaisStatus)
        }
    }
}
</script>
